import React from "react";

const FeatureContent = ({
  highlight,
  data: { heading, title, btn, img, url, text },
}) => {
  return (
    <div
      className={`flex ${
        highlight ? "flex-row-reverse" : "flex-row"
      } justify-between items-center lg:flex-col lg:justify-center nike-container`}
    >
      <div className="max-w-lg flex flex-col items-center  lg:maxmax-w-none w-ful md: text-center ">
        <h1 className="text-4xl sm:text-3xl font-bold text-gradient">
          {heading}
        </h1>
        <h1 className="text-5xl my-5 lg:text-4xl md:text-3xl sm:text-2xl  text-slate-700 xsm:whitespace-normal">
          {title}
        </h1>
        <p className="">{text}</p>
        <a
          className="flex items-center"
          rel="noreferrer"
          target="_blank"
          role="button"
          href={url}
        >
          <button className="button-theme bg-slate-800 text-slate-100 shadow-slate-800">
            {btn}
          </button>
        </a>
      </div>
      <div className="flex items-center justify-center max-w-xl w-full relative">
        <img
          src={img}
          alt={`img-/${heading}`}
          className={` ${
            highlight
              ? "h-60 lg:h-56 md:h-52 sm:h-44 xsm:36"
              : "h-72 lg:h-64 md:h-60 sm:h-48 xsm:h-44 "
          } w-auto object-fill transition-theme  rotate-6 hover:-rotate-12 transition-all duration-700 ease-in-out`}
        />
      </div>
    </div>
  );
};

export default FeatureContent;
